import type { OneJogConfig } from './types';

const DEFAULT_SCRIPT_ID = 'kenbun-widget';

/**
 * Obtiene la configuración desde el script que cargó el widget.
 * Uso: <script src="https://.../kenbun.iife.js" data-site-id="TU_CODIGO" id="kenbun-widget"></script>
 */
export function getConfigFromScript(): OneJogConfig | null {
  const script =
    document.currentScript ||
    document.getElementById(DEFAULT_SCRIPT_ID) ||
    document.querySelector<HTMLScriptElement>(`script[data-site-id]`);

  if (!script) return null;

  const siteId = script.getAttribute('data-site-id')?.trim();
  if (!siteId) return null;

  const config: OneJogConfig = {
    siteId,
    disableRecentlySoldPopup: script.getAttribute('data-disable-popup') === 'true' || script.getAttribute('data-disable-popup') === '1',
  };

  const gaId = script.getAttribute('data-ga-id');
  if (gaId) config.gaMeasurementId = gaId;

  // Firebase opcional por script (apiKey, projectId, etc. vía data-*)
  const firebaseProject = script.getAttribute('data-firebase-project');
  const firebaseApiKey = script.getAttribute('data-firebase-apikey');
  if (firebaseProject && firebaseApiKey) {
    config.firebaseConfig = {
      apiKey: firebaseApiKey,
      authDomain: `${firebaseProject}.firebaseapp.com`,
      projectId: firebaseProject,
      storageBucket: `${firebaseProject}.appspot.com`,
      messagingSenderId: script.getAttribute('data-firebase-sender-id') || '',
      appId: script.getAttribute('data-firebase-app-id') || '',
    };
  }

  return config;
}
